import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import ConfirmationBox from '../../../Components/ConfirmationBox/ConfirmationBox'
import FooterActions from '../../../Components/FooterActions'
import TemplateView from '../../../Components/TemplateView/TemplateView'
import apiClient from '../../../Util/apiClient'
import { downloadPrintPDF } from '../../../Util/Util'

export default function Expenses(props) {
  const [expenses, setExpenses] = useState([])

  const getData = () => {
    if (props.match.params.id) {
      apiClient.get(`expenses/view/${props.match.params.id}`).then(({ data }) => {
        if (data.result) {
          setExpenses(data.result)
        }
      })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const onDownloadPayslip = (isPrint = false) => {
    const ids = expenses.map((val) => val.id)
    const exeFn = (printType) =>
      downloadPrintPDF(`expenses/download/${props.match.params.id}`, { printType }, isPrint)

    if (ids.length > 1) {
      ConfirmationBox({
        title: 'Download Payslip',
        description: 'Select how you wants to download!',
        acceptText: 'Single',
        acceptText1: 'Multiple',
        canelText: 'Cancel',
        acceptFn: () => exeFn('Single'),
        acceptFn1: () => exeFn('Multiple')
      })
    } else {
      exeFn('Single')
    }
  }

  return (
    <Row>
      <Col xs={24} sm={24} md={24} lg={24} style={{ background: '#f3f3f3' }}>
        <div style={{ paddingBottom: 70 }}>
          <TemplateView contents={expenses} />
        </div>
        {!props.noEdit && (
          <FooterActions
            leftActions={[
              {
                prefix: 'flaticon-back',
                label: 'Back',
                onClick: () => props.history.push('/app/expenses')
              }
            ]}
            centerActions={[
              {
                prefix: 'flaticon-edit-1',
                label: 'Edit',
                onClick: () => props.history.push(`/app/edit-expense/${props.match.params.id}`)
              }
            ]}
            rightActions={[
              {
                prefix: 'flaticon-printer-1',
                label: 'Print',
                onClick: () => onDownloadPayslip(true)
              },
              {
                prefix: 'flaticon-download',
                label: 'Download',
                onClick: () => onDownloadPayslip()
              }
            ]}
          />
        )}
      </Col>
    </Row>
  )
}
